import { PROD_DEFAULT_REGION } from 'state/intl/constants';
import { t } from 'state/intl/translations';
import {
  ISOs,
  postalCodeStringLocaleKey,
  regionInputProperties,
  regionStringLocaleKey,
} from 'utils/form/constants';

const useCreditCardFormProps = (isoCountryCode: ISOs = ISOs[PROD_DEFAULT_REGION]) => {
  // construct postal code props based on users country
  const postalCodeInputProps = {
    label: t(postalCodeStringLocaleKey[isoCountryCode]),
  };
  const regionInputProps = {
    label: t(regionStringLocaleKey[isoCountryCode]),
    ...regionInputProperties[isoCountryCode],
  };

  return { postalCodeInputProps, regionInputProps };
};

export default useCreditCardFormProps;
